module.exports = __webpack_public_path__ + "static/media/2.4d83b945.png";